<template>
    <oc-page title="Account - Sign In">
        <div class="auth-box" id="standard-login">

            <img v-if="$root.customerLogo !== false" :src="$root.customerLogo" alt="Customer logo" class="customer-logo" />

            <div class="beacon-holder mb-3">
                <div class="hr"></div>

                <div class="beacon-container beacon-normal object-color-silver">
                    <div class="auth-beacon" :class="{'beacon-loading': loading}">
                        <i class="glyphicon glyphicon-user user-icon"></i>
                        <div class="auth-beacon-border"></div>
                    </div>
                </div>
            </div>

            <div class="infobox infobox-error mb-4" v-if="hasFormErrors">
                <span class="icon error-16"></span>
                <p class="mb-0" v-if="formGlobalErrorMessage.length > 0">{{formGlobalErrorMessage}}</p>
                <p class="mb-0" v-else>{{formErrorMessage}}</p>

                <ul class="mt-1 mb-0 pl-3" v-if="Object.keys(formFieldErrors).length > 0">
                    <li v-for="(msg, field) of formFieldErrors" :key="field">
                        <template v-if="msg.indexOf(form.getFieldLabel(field)) === 0">
                            {{msg}}
                        </template>
                        <template v-else>
                            {{form.getFieldLabel(field)}}: {{msg}}
                        </template>
                    </li>
                </ul>
            </div>

            <oc-flash-messages />

            <h4 class="section-title">Sign In</h4>
            <div class="hr"></div>

            <oc-form :model="form" @submit.native.prevent="doSignIn" class="mt-4">

                <oc-form-field
                    target="username"
                    label="Username"
                    :displayLabel="false"
                    placeholder="Username"
                    :inputAttrs="{autofocus: true, required: true, autocomplete: 'off'}"
                    :inputPrepend="{component: 'i', attrs: {class: 'glyphicon glyphicon-user'}}"
                    :indicationValid="false"
                    :required="false"
                />

                <oc-form-field
                    target="password"
                    :input="passwordComponent"
                    :inputAttrs="{required: true}"
                    label="Password"
                    :displayLabel="false"
                    placeholder="Password"
                    :inputPrepend="{component: 'i', attrs: {class: 'glyphicon glyphicon-lock'}}"
                    :inputAppend="{
                        component: 'i',
                        attrs: {class: ['show-pass glyphicon', passwordIcon], title: 'Show password'},
                        on: {mousedown: showPassword, mouseleave: hidePassword, mouseup: hidePassword}
                    }"
                    :indicationValid="false"
                    :required="false"
                />

                <oc-form-field
                    target="remember"
                    label="Remember Me"
                    theme="checkbox"
                    input="oc-checkbox-input"
                    :displayIndication="false"
                />

                <captcha
                    v-if="loginAttempts >= captchaOnLoginAttempts"
                    :url="captchaImageURL"
                    :fieldAttrs="{displayLabel: false, placeholderPrefix: ''}"
                />

                <div class="clearfix" />

                <oc-submit-button-input class="mt-3 mb-3 btn btn-info btn-block" :disabled="loading">
                    <oc-icon type="sign-in" />
                    Sign in
                </oc-submit-button-input>

                <oc-button-input v-if="$root.authInfo.users.length > 0" class="btn btn-default btn-block" @click="$emit('choose-account')">
                    <oc-icon type="user-circle" />
                    Choose account
                </oc-button-input>

            </oc-form>
        </div>
    </oc-page>
</template>

<script>
import SignInMixin from '@/pages/auth/mixins/SignInMixin'

export default {
    name: "login-company",
    mixins: [SignInMixin],
    data() {
        return {
        }
    }
}
</script>
